module.exports = __webpack_public_path__ + "static/img/slogn-de.8f243d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/slogn/slogn-de.png
// module id = 1j1C
// module chunks = 1